import { useMutation, useQueryClient } from "@tanstack/react-query";

import { duplicateSoilSightProject } from "services";

import { useIsAuthenticated } from "utils";

import { DUPLICATE_SOIL_SIGHT_PROJECT, LIST_SOIL_SIGHT_PROJECTS } from "consts";

export const useDuplicateSoilSightProject = (klimFarmId: string) => {
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [DUPLICATE_SOIL_SIGHT_PROJECT],
    mutationFn: ({ soilSightProjectId, name }: { soilSightProjectId: string; name: string }) => {
      if (!isAuthenticated) return Promise.reject(new Error("Not Authorized"));
      return duplicateSoilSightProject(soilSightProjectId, name);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [LIST_SOIL_SIGHT_PROJECTS, klimFarmId] });
    },
  });
};
